<template>
  <div class="Talent-detail bg-round bg-fff">
    <div class="container" id="w-1200px">
      <Bread :list="breadList" class="ma-t-10" />
      <div class="flex ma-t-30">
        <img
          :src="detail.Image"
          alt=""
          srcset=""
          width="360"
          height="453"
          class="img_cover img-portrait b-r-15"
        />
        <div class="flex1 pa-l-40">
          <div class="pa-t-20 font-bold">{{ detail.Name }}</div>
          <div class="pa-t-20 flex">
            <div class="pa-lr-10 pa-tb-5 b-r-10 bg-fb004d c-fff ma-r-10"  v-for="(item, index) in detail.CategoryList" :key="index">{{ item }}</div>
          </div>
          <div class="pa-t-20" v-if="detail.IsVip">
            E-mail: {{ detail.Email }}
          </div>
        </div>
      </div>

      <div class="menu-item fon-24 ma-t-80">
        <div class="font-bold">个人简介</div>
        <div class="font-bold">Personal Profile</div>
        <img
          src="../img/index/index21.png"
          class="item-right width90"
          alt=""
          srcset=""
        />
        <img
          src="../img/index/index22.png"
          class="item-left"
          alt=""
          srcset=""
        />
      </div>
      <div class="white-s-pl ma-t-10" v-html="detail.AwardRecord"></div>
      <div class="ma-t-10 lh-html" v-html="detail.Content">
      </div>
      <Empty :isShow="!detail.Content && !detail.AwardRecord"></Empty>

      <div class="menu-item fon-24 ma-t-80">
        <div class="font-bold">作品记录</div>
        <div class="font-bold">Work record</div>
        <img
          src="../img/index/index21.png"
          class="item-right width90"
          alt=""
          srcset=""
        />
        <img
          src="../img/index/index22.png"
          class="item-left"
          alt=""
          srcset=""
        />
      </div>
      <div class="white-s-pl ma-t-10" v-html="detail.WorkRecord">
      </div>
      <Empty :isShow="!detail.WorkRecord"></Empty>

      

    </div>
  </div>
</template>

<script>
import Bread from "../components/Bread.vue";
import { getTalentDetail } from "../api.js";
export default {
  components: {
    Bread,
  },
  data() {
    return {
      breadList: [
        {
          name: "翠麟精英",
          path: "/talent/index",
        },
        {
          name: "详情",
          path: "/talent/detail",
        },
      ],
      id:0,
      detail:{}
    };
  },
  created(){
    this.id=this.$route.query.id
    this.loadData()
  },
  methods:{
    loadData(){
      getTalentDetail({id:this.id}).then(res=>{
        this.detail=res.data.Data
      })
    }
  },
  watch:{
    '$route.query.id'(val){
      if(val){
        this.id=this.$route.query.id
        this.loadData()
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.Talent-detail .container {
  min-height: 1150px;
  // background: #ffffff;
  box-sizing: border-box;
  padding: 30px 40px;
}
.menu-item {
  position: relative;
  .item-right {
    position: absolute;
    right: 0;
    top: 0;
  }
  .item-left {
    position: absolute;
    left: 0;
    top: 0;
  }
}
.img-portrait {
  border: 4px solid #fb004d;
}
</style>